import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SharedModule } from './shared/shared.module';
import { environment } from 'src/environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { LoginModule } from './module/login/login.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TokenInterceptor } from './shared/interceptors/tokenInterceptor';
import { ApiModule } from './api/identity/api.module';
import { ApiModule as jobTicketModule } from './api/job-ticket/api.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      timeOut: 1000,
      positionClass: 'toast-top-right',
    }),
    LoginModule,
    ApiModule.forRoot({ rootUrl: environment.apiUrlIdentity }),
    jobTicketModule.forRoot({ rootUrl: environment.apiUrlJobTicket }),
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  exports: [ToastrModule],
})
export class AppModule {}
